import { useLayoutEffect, useRef } from "react";

const SeriesList = ({
  options,
  onSelectPump,
  currentSelectedPump,
  savedScrollTop,
  onScrollChange,
  seriesId,
}) => {
  // Определяем заголовок и параметры колонки в зависимости от ID серии
  const getLastColumnConfig = () => {
    // Серия 34 (EWC) — "Тип монтажа" (группа 5, параметр 215)
    if (seriesId === "34") {
      return { header: "Тип монтажа", groupId: 5, paramId: 215 };
    }
    // Серия 26 (DLT) — "Емкость резервуара" (группа 7, параметр 221)
    if (seriesId === "26") {
      return { header: "Емкость резервуара", groupId: 7, paramId: 221 };
    }
    // По умолчанию — "Номинальная скорость вращения" (группа 4, параметр 118)
    return { header: "Номинальная скорость вращения", groupId: 4, paramId: 118 };
  };

  const lastColumnConfig = getLastColumnConfig();

  // Функция для получения значения последней колонки
  const getLastColumnValue = (item) => {
    const paramsGroup = item.param?.find((obj) => obj.id === lastColumnConfig.groupId);
    if (!paramsGroup || !paramsGroup.params) return "";

    const param = paramsGroup.params.find(
      (p) => p.id === lastColumnConfig.paramId
    );
    return param?.value ?? "";
  };
  const rowRefs = useRef({});
  const tableBodyRef = useRef(null);

  const openPumpHandler = (name, id) => {
    onSelectPump(name, id);
  };

  const handleScroll = () => {
    if (tableBodyRef.current) {
      onScrollChange(tableBodyRef.current.scrollTop);
    }
  };

  useLayoutEffect(() => {
    if (tableBodyRef.current && savedScrollTop !== undefined) {
      tableBodyRef.current.scrollTop = savedScrollTop;
    }
  }, [savedScrollTop]);

  return (
    <div className="w-100 full-range-list">
      <table className="full-range-list_table w-100 full-range-list">
        <thead>
          <tr>
            <th className="font-title first-child">
              <h4>Наименование</h4>
            </th>
            <th className="font-title second-child">
              <h4>Артикул</h4>
            </th>
            <th className="font-title">
              <h4>Номинальная мощность</h4>
            </th>
            <th className="font-title">
              <h4>Номинальное напряжение</h4>
            </th>
            <th className="font-title last-child">
              <h4>{lastColumnConfig.header}</h4>
            </th>
          </tr>
        </thead>
        <tbody
          ref={tableBodyRef}
          onScroll={handleScroll}
          className={`${options?.length > 5 ? "scroll-y" : "padding-right-3x"}`}
        >
          {/* Если ничего не найдено */}
          {options?.length === 0 && (
            <div className="result-empty w-100">
              <h4>Ничего не найдено</h4>
            </div>
          )}
          {/* Если есть насосы */}
          {options?.map((item) => {
            return (
              <tr
                key={item.name}
                ref={(el) => (rowRefs.current[item.name] = el)}
                className={
                  item.name === currentSelectedPump?.name ? "active" : ""
                }
                onClick={() => openPumpHandler(item.id)}
              >
                <td className="text-m first-child">{item.name}</td>
                <td className="text-m second-child">{item.article}</td>
                <td className="text-m">{item.power}</td>
                <td className="text-m">{item.voltage}</td>
                <td className="text-m last-child">
                  {getLastColumnValue(item)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SeriesList;
